//changed due to package upgrade
import AppCard from '@projectK/components/AppCard';
import React, { useEffect, useState } from 'react';
import {
  alpha,
  Autocomplete,
  Button,
  Grid,
  Stack,
  TextField,
} from '@mui/material';
import AppGridContainer from '@projectK/components/AppGridContainer';
import PropTypes from 'prop-types';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import dayjs from 'dayjs';
import jwtAxios from '@projectK/services/auth/JWT';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import {isParent, isStudent } from '@projectK/context/RolesProvider';

const WaiversLogFilter = ({
  signedDateFilter,
  setUserFilter,
  setSignedDateFilter,
  setPage,
  verbiageSettings,
}) => {
  const companyTheme = CompanyTheme();
  const { user } = useAuthUser();
  const [isExpandFilter, setIsExpandFilter] = useState(true);
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);

  const handleFilterChange = (filterType, value) => {
    if (filterType === 'userId') {
      setUserFilter(value ? value.id : '');
      setPage(0);
    }
    if (filterType === 'signedOn') {
      if (value === '') {
        setSignedDateFilter('');
      } else {
        setSignedDateFilter(value);
      }
      setPage(0);
    }
  };
  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  const toggleFilter = () => {
    setIsExpandFilter(!isExpandFilter);
  };

  const clearFilter = () => {
    setSignedDateFilter('');
    setUserFilter('');
    setSelectedUser(null);
    setPage(0);
  };

  const filteredDate = new Date(
    `${signedDateFilter?.substring(0, 10)}T12:01:00`,
  );
  useEffect(() => {
    if (!isStudent(user)) {
      fetchUsersData();
    }
  }, [searchTerm]);

  const fetchUsersData = async () => {
    setLoading(true);
    try {
      let url = `/users`;
      if (isParent(user)) {
        url = `/user-members/${user.id}`;
      }
      const response = await jwtAxios.get(url, {
        params: {
          perPage: 'all',
          search: searchTerm,
        },
      });
      const { data } = response;
      setUsers(data?.list);
      setLoading(false);
    } catch (error) {
      setUsers([]);
      setLoading(false);
    }
  };

  return (
    <AppCard
      className='right-main-content'
      title={`Filter ${verbiageSettings.waiver_name || 'Waiver'}
       Log`}
      style={{ position: 'relative' }}
      onClick={toggleFilter}
    >
      <AppGridContainer spacing={5} onClick={stopPropagation}>
        {!isStudent(user) && (
          <Grid  size={{ xs: 12, md: 4,sm: 6,  }}>
          <Autocomplete
              options={(!loading ? users : []).sort((a, b) =>
                (a.first_name + ' ' + a.last_name).localeCompare(
                  b.first_name + ' ' + b.last_name,
                  undefined,
                  { numeric: true, sensitivity: 'base' },
                ),
              )}
              getOptionLabel={(option) =>
                `${option.first_name} ${option.last_name} - ${option.email}`
              }
              value={selectedUser}
              onChange={(_, value) => {
                handleFilterChange('userId', value || {});
                setSelectedUser(value);
              }}
              inputValue={searchTerm}
              onInputChange={(_, value) => setSearchTerm(value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label='Participants'
                  variant='outlined'
                />
              )}
            />
          </Grid>
        )}
        <Grid  size={{ xs: 12, md: 4,sm: 6,  }}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Stack spacing={1}>
              <DatePicker
                label='Signed On'
                sx={{
                  width: '100%',
                  backgroundColor: 'background.paper',
                  color: 'text.primary',
                }}
                value={signedDateFilter ? filteredDate : null}
                renderInput={(params) => <TextField {...params} />}
                onChange={(value) => {
                  const formattedDate = dayjs(value)
                    .startOf('day')
                    .format('YYYY-MM-DD');
                  handleFilterChange(
                    'signedOn',
                    formattedDate === 'Invalid Date' ? '' : formattedDate,
                  );
                }}
              />
            </Stack>
          </LocalizationProvider>
        </Grid>

        <Grid  size={{ xs: 12, md: 4,sm: 6,  }}>
          <Button
            variant='outlined'
            sx={{
              borderColor: companyTheme ? companyTheme.primary.main : '#2196f3',
              '&:hover': {
                borderColor: companyTheme
                  ? alpha(companyTheme.primary.main, 0.8)
                  : alpha('#2196f3', 0.8),
              },
              color: companyTheme ? companyTheme.primary.main : '#2196f3',
            }}
            onClick={clearFilter}
          >
            Clear Filter
          </Button>
        </Grid>
      </AppGridContainer>
    </AppCard>
  );
};

export default WaiversLogFilter;

WaiversLogFilter.propTypes = {
  verbiageSettings: PropTypes.bool.isRequired,
  setPage: PropTypes.func.isRequired,
  signedDateFilter: PropTypes.func.isRequired,
  setUserFilter: PropTypes.func.isRequired,
  setSignedDateFilter: PropTypes.func.isRequired,
};
